import { StrategicAllyFilter } from '../../../../../shared/types/modules/strategicAlly';

export const initialValues: StrategicAllyFilter = {
    name: '',
    code: '',
};
